'use strict';

var SIZEBAY_SESSION_ID_V4;
var host;
var skuId;
var masterSkuId;
var objectBody;
var URLSIZEBAY;
var permalink;
var tenantId;
var sizebaySettings;
var endPointProd;
var endPointTest;
var endPoints;
var endPointAddtoCart;
var endPointOrder;
var dataOrder;
var orderId;
var resultHost;
var sandboxes;
var items;

var ARG_COUNTRYCODE = 'AR'; // se deja valor quemado ya que solo hay venta en el pais.
var ARG_CURRENCYCODE = 'ARS'; // se deja valores quemado ya que solo se maneja una moneda

/* Track the device information */
function isMobile() {
    const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

    return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
}

function isTablet() {
    const toMatch = [/iPad/i, /Tablet/i];

    return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
}

function isWebView() {
    return window.navigator.standalone === true;
}

/** This function returns the current device from the Window object. **/
function getCurrentDevice() {
    if (isMobile() && !isWebView()) return 'mobile';
    if (isWebView()) return 'app';
    if (isTablet()) return 'tablet';
    return 'desktop';
}


/**
* validateHost: This method checks the stage we are working on.
**/

function validateHost() {
    host = document.location.hostname;
    sandboxes = ['sandbox', 'dev', 'staging'];
    resultHost = sandboxes.some(hostName => host.toString().includes(hostName));
    return resultHost;
}

/**
* getEndpoints: This method differenciates whether we are working on (Cart or PDP/ Prod or Test) and creates different  Endpoints depending on that.
**/

function getEndpoints() {
    endPointProd = sizebaySettings.endPoint_Prod;
    endPointTest = sizebaySettings.endPoint_Test;
    endPoints = endPointProd; // validateHost() ? endPointTest : endPointProd;
    endPointAddtoCart = endPoints.AddtoCart;
    endPointOrder = endPoints.Order;
}

/**
* getSettingSizebay: This method obtains contentSlot(sizebay-settings)'s data.
* With this object data, we are able to access to the tenantId and endpoints.
**/
function getSettingSizebay() {
    if ($('#sizebaySettings').length) {
        sizebaySettings = JSON.parse(document.getElementById('sizebaySettings').value);
        tenantId = sizebaySettings.tenantId;
        getEndpoints();
    }
}

/**
* deleteVariant: This method remove the product variant.
**/
function deleteVariant(masterSku) {
    let skuArray = [];
    skuArray = masterSku.split('_');
    skuId = skuArray[0] + '_' + skuArray[1];
    skuId = skuId.toLowerCase();
}

/**
* getPermalink: This method obtains permalink URL.
**/
function getPermalink() {
    host = document.location.hostname;
    permalink = 'https://' + host + '/' + masterSkuId;
}

/**
* getPermalink: This method obtains permalink URL.
**/
function getPermalinkMaster(masterSku) {
    host = document.location.hostname;
    permalink = 'https://' + host + '/' + masterSku.toLowerCase();
}


/**
* objectConstructorPDP: This method obtains PDP object with data(site credentials)we have previously acessed .
**/
function objectConstructorPDP() {
    URLSIZEBAY = endPointAddtoCart;
    objectBody = {
        products: [
            {
                permalink
            }
        ],
        tenantId
    };
}

function objectConstructorPOD() {
    dataOrder = JSON.parse(document.querySelector('#orderInformations').value);
    URLSIZEBAY = endPointOrder;
    orderId = dataOrder.orderNumber;
    let arrayItemsOrder = dataOrder.items.items;
    items = arrayItemsOrder.map(item => {
        var talle = item.variationAttributes[0].displayValue;
        var masterSKU = item.masterId;
        getPermalinkMaster(masterSKU);
        return {
            permalink: permalink,
            price: parseFloat(item.priceTotal.price.replace('$', '')),
            quantity: item.quantity,
            size: talle,
            feedProductId: masterSKU,
            sku: item.id
        };
    });
    var currency = ARG_CURRENCYCODE;
    var country = ARG_COUNTRYCODE;

    objectBody = {
        orderId,
        items,
        tenantId,
        currency,
        country
    };
}

/**
* getSku: This method obtains product's SKU (stock-keeping unit) unique code.
**/
function getSku() {
    masterSkuId = $('#masterProductId').val();
    skuId = document.querySelector('meta[property="og:url"]').content.split('/').pop().split('.html')[0].toLowerCase();
}

/**
* getCookieSizeBay: This method obtains the cookie from the site.
**/
function getCookieSizeBay() {
    SIZEBAY_SESSION_ID_V4 = document.cookie.replace(/(?:(?:^|.*;\s*)SIZEBAY_SESSION_ID_V4\s*\=\s*([^;]*).*$)|^.*$/, '$1');
    SIZEBAY_SESSION_ID_V4 = SIZEBAY_SESSION_ID_V4 || '12C3076B190B9328486bd3a74a4a9fec5a4f8cdb1f00';
}

/**
* postSizeBay: This method sends data to sizebay.
**/
function postSizeBay() {
    getCookieSizeBay();
    let xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            alert(this.responseText);
        }
    };
    xhttp.open('POST', URLSIZEBAY + SIZEBAY_SESSION_ID_V4, true);
    xhttp.setRequestHeader('Content-type', 'application/json');
    xhttp.setRequestHeader('device', getCurrentDevice());
    xhttp.send(JSON.stringify(objectBody));
}

/**
* postSizeBay: Depending on the siteCredentials (whether the data we obtain is true or false), this method sends data to the cart.
**/
function addtoCartSizeBay() {
    $('.add-to-cart').on('click', function () {
        getSettingSizebay();

        if ($('#sizebaySettings').length) {
            getSku();
            getPermalink();
            objectConstructorPDP();
            postSizeBay();
        }
    });
}
/**
* postSizeBay: Depending on the siteCredentials (whether the data we obtain is true or false), this method executes
objectConstructorPOD() and postSizeBay()
**/
function OrderSizeBay() {
    getSettingSizebay();
    if ($('#sizebaySettings').length) {
        objectConstructorPOD();
        postSizeBay();
    }
}

/**
* validationPage: Validates wether we are working on PDP or Cart.
**/
function validationPage() {
    let pageDescription = document.querySelector('#pageDescription').value;
    pageDescription === 'PDP' ? addtoCartSizeBay() : OrderSizeBay();
}

function onInitSizebay() {
    validationPage();
}


module.exports = {
    onInitSizebay: onInitSizebay
};
